import { Box } from '@mui/material';
import ErrorMessage from '../error-message/error-message.component';

const ErrorMessages = ({ error }) => {
  if (!!error.types) {
    return (
      <Box component="ul" my={0} px={3}>
        {Object.entries(error.types).map(
          ([key, errorMessage]: [string, string]) => (
            <ErrorMessage key={key} message={errorMessage} />
          ),
        )}
      </Box>
    );
  } else if (!!error.type) {
    return (
      <Box component="ul" my={0} px={3}>
        <ErrorMessage key={error.type} message={error.message} />
      </Box>
    );
  } else return null;
};
export default ErrorMessages;
